// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1Pha5","selects":"Documents_selects__388vG"};